import { ChangeDetectorRef, Component, Injectable, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProjectService } from '../../Services/project.service';
import swal from 'sweetalert2';
import { ActivatedRoute, CanDeactivate, Router, UrlTree } from '@angular/router';
import moment from 'moment';
import { DatePipe, ViewportScroller } from '@angular/common';
import { SharedService } from 'src/app/Services/sharedService';
import { Observable, Subscription, map, switchMap } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogTemplateComponent } from 'src/app/dialog-template/dialog-template/dialog-template.component';
import { AddEmailComponent } from 'src/app/addEmail/add-email/add-email.component';
import { DemoReportModalComponent } from 'src/app/QuotaBanner/demo-report-modal/demo-report-modal.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { time24FormatValidator } from 'src/app/utils/time24.validator';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { DeviceDetectionService } from 'src/app/Services/device-detection.service';
import { PhoneVerificationService } from 'src/app/Services/phone-verification.service';
import { TokenEncryptionService } from 'src/app/Services/token-encryption.service';
import { Shift, ShiftEmployee } from 'src/app/models/shift.model';
import { ShiftService, ShiftPayload } from 'src/app/Services/shift.service';
import { UserService } from 'src/app/Services/user.service';
import { BulkUpdateSettingsComponent } from '../bulk-update-settings/bulk-update-settings.component';
import { globalSettingsTime } from 'src/app/config';
import { EntitlementsService } from 'src/app/Services/entitlements.service';
import { EntitlementKey } from 'src/app/entitlements/entitlement-keys';
import { resolveScreenshotIntervalFloorMinutes } from 'src/app/entitlements/screenshot-interval-limit.util';
import { SettingsEntitlementsService } from 'src/app/Services/settings-entitlements.service';
import { CompanyAddOnEntitlement } from 'src/app/entitlements/settings-entitlements.types';
import { environment } from 'src/environments/environment';

import { ContactPhoneCaptureService } from 'src/app/onboarding-checklist/contact-phone-capture.service';
import { Country } from 'src/app/countriesConfig';
@Component({
  selector: 'app-user-setting-panel',
  templateUrl: './user-setting-panel.component.html',
  styleUrls: ['./settings-shell.theme.css', './user-setting-panel.component.css'],
  providers: [DatePipe],
  standalone: false
})

export class UserSettingPanelComponent {

  isFieldDisabled = true;
  globalSettings: FormGroup
  anotherSettings;
  totalUser = 0;
  availableUser = 0;
  useUser = 0;
  isAdmin = false;
  showShiftDrawer = false;
  editingShift: Shift | null = null;
  isEditMode = false;
  globalSettingsData: any
  userId;
  isPersonalized = true;
  isPeriodic = true;
  isAppChange = true;
  userName = '';
  userData: any = null; // Store full user data for profile image
  quotaStatus = '';
  isWebcamCaptureEntitled = false;
  /** False until user/add-on responses decide webcam assignment. Avoids painting the toggle off early. */
  private webcamEntitlementKnown = false;
  companyAddOns: CompanyAddOnEntitlement[] = [];
  companyAddOnLimits: any = {};
  addOnStateMessage = '';
  isIntegratingConduct = false;
  isConductIntegrated = false;
  isConductEnabled = false;
  conductStatusError = false;
  isCheckingConductStatus = true;
  isDisconnectingConduct = false;
  conductUrl = environment.app.conductUrl || '';

  // Profile image methods
  getProfileImageUrl(): string | null {
    if (!this.userData) return null;

    // Check for profile_image_url in meta first (from API response)
    if (this.userData.meta && this.userData.meta.profile_image_url) {
      return this.userData.meta.profile_image_url;
    }

    // Check for profile_image in meta (alternative custom field)
    if (this.userData.meta && this.userData.meta.profile_image) {
      return this.userData.meta.profile_image;
    }

    // Fallback to avatar_urls (WordPress default)
    if (this.userData.avatar_urls && this.userData.avatar_urls[96]) {
      return this.userData.avatar_urls[96];
    }

    return null;
  }

  getDisplayImageUrl(): string {
    // Return profile image if available, otherwise return default placeholder
    return this.userData?.meta?.profile_image_url || null;
  }

  getDefaultImageUrl(): string {
    // Return a data URI for a simple default placeholder icon
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 24 24' fill='%23B3B3B3'%3E%3Cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3E%3C/svg%3E";
  }

  imageError: boolean = false;
  onImageError(event: any): void {
    this.imageError = true;
    event.target.style.display = 'none';
  }

  getInitials(): string {
    if (!this.userData || !this.userData.name) return 'U';

    const nameParts = this.userData.name.trim().split(' ');
    if (nameParts.length >= 2) {
      return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
    } else if (nameParts.length === 1) {
      return nameParts[0].charAt(0).toUpperCase();
    }

    return 'U';
  }
  quota_expired_date;
  isSearchDiv = false;
  searchData = [
  ]
  addEmailArr = [];
  availableData = [];
  filterSearchData = this.searchData;
  txtSettings = ' settings';

  // Report Recipients Email properties
  reportRecipientEmails: string[] = [];
  emailInputControl = new FormControl('', [Validators.email]);
  separatorKeysCodes: number[] = [ENTER, COMMA];
  readonly maxEmails = 5;
  id: string;

  // WhatsApp Daily Insights recipients (seeded from workspace phone_number; stored separately)
  workspacePhone = '';
  whatsappOptedIn = false;
  whatsappNumbers: string[] = [];
  whatsappCountries: Country[] = [];
  whatsappDialCode = '+91';
  whatsappNational = '';
  readonly maxWhatsappNumbers = 3;
  private whatsappSeedWriteInFlight = false;
  private initialDeliveryEmails: string[] = [];
  private initialWhatsappNumbers: string[] = [];
  private initialWhatsappOptedIn = false;

  /** Job-based section ids: capture | tracking | schedule | delivery | bulk */
  activeTab: string = 'capture';

  /** Employee settings sections: capture | tracking */
  activeUserTab: string = 'capture';

  readonly settingsSections = [
    { id: 'capture', label: 'Capture', hint: '', icon: 'photo_camera' },
    { id: 'tracking', label: 'Tracking', hint: '', icon: 'tune', entitlementKey: EntitlementKey.advanced_tracking_controls },
    { id: 'schedule', label: 'Schedule', hint: '', icon: 'calendar_today', entitlementKey: EntitlementKey.multiple_shifts },
    { id: 'delivery', label: 'Delivery', hint: '', icon: 'mark_email_read' },
    { id: 'bulk', label: 'Bulk update', hint: '', icon: 'group', entitlementKey: EntitlementKey.bulk_settings_update },
  ] as const;

  private readonly oldTabToSection: Record<string, string> = {
    reports: 'delivery',
    screenshots: 'capture',
    tracking: 'tracking',
    shifts: 'schedule',
    integrations: 'delivery',
    'bulk-update': 'bulk',
    capture: 'capture',
    schedule: 'schedule',
    delivery: 'delivery',
    bulk: 'bulk',
  };

  private readonly oldUserTabToSection: Record<string, string> = {
    screenshots: 'capture',
    tracking: 'tracking',
    capture: 'capture',
  };

  showCaptureAdvanced = false;

  @ViewChild(BulkUpdateSettingsComponent) bulkUpdateSettingsComponent!: BulkUpdateSettingsComponent;
  // Shift state
  isManager: boolean = false;
  shifts: Shift[] = [];
  shiftEmployees: ShiftEmployee[] = [];
  isLoadingShifts = false;
  shiftLimitReached = false;
  isSubmittingShift = false;
  screenshotCaptureMinMinutes = 1;
  private entitlementsStateSub?: Subscription;
  private inputDebounceTimeouts: { [key: string]: any } = {};

  constructor(
    public formBuilder: FormBuilder,
    public _projectService: ProjectService,
    private _route: ActivatedRoute,
    private datePipe: DatePipe,
    private _sharedServices: SharedService,
    private scroller: ViewportScroller,
    private dialog: MatDialog,
    private _router: Router,
    private _snackBar: MatSnackBar,
    private deviceDetectionService: DeviceDetectionService,
    private phoneVerificationService: PhoneVerificationService,
    private tokenEncryptionService: TokenEncryptionService,
    private shiftService: ShiftService,
    private userService: UserService,
    private entitlementsService: EntitlementsService,
    private settingsEntitlementsService: SettingsEntitlementsService,
    private contactPhoneCapture: ContactPhoneCaptureService,
    private cdr: ChangeDetectorRef
  ) {
    this.whatsappCountries = this.contactPhoneCapture.getCountries();
    this.whatsappDialCode = this.contactPhoneCapture.defaultDialCode;
  }
  onGroupSelect() {
    this.availableData = this.globalSettings.get('summary_Search').value;
  }
  deleteSummaryItem(user) {
    const summarySearchControl = this.globalSettings.get('summary_Search').value;
    const index = summarySearchControl.indexOf(user);

    if (index !== -1) {
      summarySearchControl.splice(index, 1);
      this.availableData = summarySearchControl;
      this.globalSettings.get('summary_Search').patchValue(summarySearchControl);
    }
  }
  deleteSummaryAddEmailItem(user) {

    const index = this.addEmailArr.indexOf(user);

    if (index !== -1) {
      this.addEmailArr.splice(index, 1);
    }
  }
  addNewEmail() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.autoFocus = true;

    dialogConfig.minWidth = 400;

    dialogConfig.panelClass = 'centered-dialog';

    const dialogRef = this.dialog.open(AddEmailComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result != true) {
        if (this.addEmailArr.length > 0) {
          const index = this.addEmailArr.indexOf(result);

          if (index == -1) {
            this.addEmailArr.push(result)
          }
        } else {
          this.addEmailArr.push(result)
        }
      }
    })
  }
  getDevList() {
    this._projectService
      .getUserList(1, 100)
      .subscribe((user: any) => {
        this.searchData = [];
        this.searchData = user;
        this.filterSearchData = this.searchData;
      });
  }
  onKey(value?: any) {
    this.isSearchDiv = true;
    this.searchData = this.filterSearchData;
    let svalue = value.toUpperCase();
    this.searchData = this.searchData.filter((ele) => {
      return ele.email.toUpperCase().includes(svalue);
    });
    if (value == "") {
      this.isSearchDiv = false;
      this.searchData = this.filterSearchData;
    }
  }
  selectSummaryEmail(strEmail) {
    this.globalSettings.get('summary_Search').setValue(strEmail);
    this.isSearchDiv = false;
  }
  ngOnInit(): void {
    this.getDevList();
    this.getUSer();
    this.paramsListener();
    this.checkConductIntegrationStatus();
    this.entitlementsStateSub = this.entitlementsService.stateChanged$.subscribe(() => {
      this.refreshScreenshotIntervalFloor();
      this.applyEntitlementFieldLocks();
      if (this.globalSettings) {
        this.cdr.detectChanges();
      }
    });

    this._route.queryParams.subscribe(params => {
      const tab = params['tab'];
      if (tab) {
        if (this.userId) {
          this.activeUserTab = this.resolveUserSection(tab);
        } else {
          this.activeTab = this.resolveSection(tab);
          if (this.activeTab === 'delivery') {
            this.checkConductIntegrationStatus();
          }
        }
      }
    });

    let user = this.tokenEncryptionService.getEncryptedItem<any>('user');
    if (user) {
      this.isWebcamCaptureEntitled = this._projectService.isEntitlementEnabled(user, EntitlementKey.webcam_capture);
      const roleArr = user.role;

      // Check if user is a manager
      let managerRole = roleArr.filter((ele: string) => {
        return (ele.toLowerCase().includes("manager"));
      })
      this.isManager = managerRole.length > 0;

      // Managers default to Apply at scale when entitled (only if not overridden by query param)
      if (this.isManager && !this._route.snapshot.queryParams['tab']) {
        this.activeTab = this.canBulkSettingsUpdate() ? 'bulk' : 'capture';
      }

      let tlRole = roleArr.filter((ele) => {
        return (ele.toLowerCase().includes("lead"));
      })
      if (tlRole.length == 0) {
        if (this.userId) {
          this.getUserDetails();
        } else {
          this.getGlobalSettings();
        }
        this._sharedServices.settingScroller().subscribe((result: any) => {
          this.scroller.scrollToAnchor(result);
        });
      } else {
        this._router.navigateByUrl('dashboard');
        return;
      }
    }

    window.addEventListener('message', this.handleIframeMessage.bind(this));
  }

  ngOnDestroy() {
    this.entitlementsStateSub?.unsubscribe();
    window.removeEventListener('message', this.handleIframeMessage.bind(this));
  }

  paramsListener() {
    this._route.params.subscribe((params) => {
      this.userId = params['userId'];
      if (this.userId) {
        this.activeTab = '';
        const tab = this._route.snapshot.queryParams['tab'];
        if (tab) {
          this.activeUserTab = tab;
        }
      } else {
        const tab = this._route.snapshot.queryParams['tab'];
        if (tab) {
          this.activeTab = tab;
        }
      }
      this.applySettingsTabFromQuery();
    })

    this._route.queryParams.subscribe(() => {
      this.applySettingsTabFromQuery();
    });
  }

  private resolveSection(tab: string | null | undefined): string {
    if (!tab) {
      return this.activeTab || 'capture';
    }
    return this.oldTabToSection[tab] || tab;
  }

  private resolveUserSection(tab: string | null | undefined): string {
    if (!tab) {
      return this.activeUserTab || 'capture';
    }
    return this.oldUserTabToSection[tab] || (['capture', 'tracking'].includes(tab) ? tab : 'capture');
  }

  private applySettingsTabFromQuery(): void {
    const tab = this._route.snapshot.queryParamMap.get('tab');
    if (tab && !this.userId) {
      this.activeTab = this.resolveSection(tab);
    }

    const userTab = this._route.snapshot.queryParamMap.get('userTab');
    if (userTab && this.userId) {
      this.activeUserTab = this.resolveUserSection(userTab);
    } else if (tab && this.userId) {
      this.activeUserTab = this.resolveUserSection(tab);
    }
  }

  isSettingsSectionVisible(sectionId: string): boolean {
    if (sectionId === 'bulk') {
      return this.showBulkUpdateTab();
    }
    return this.isAdmin;
  }

  sectionEntitlementKey(sectionId: string): string | null {
    const section = this.settingsSections.find((s) => s.id === sectionId) as { entitlementKey?: string } | undefined;
    return section?.entitlementKey ?? null;
  }

  isSectionLocked(sectionId: string): boolean {
    const key = this.sectionEntitlementKey(sectionId);
    return !!key && this.isSettingsFeatureLocked(key);
  }

  getUserDetails() {
    this._projectService.getEmployeeData(this.userId).subscribe(
      (data: any) => {
        this.userName = data.name + "'s";
        this.userData = data; // Store full user data for profile image
        if (Array.isArray(data.meta.settings)) {
          if (!data.meta.settings.length) {
            this.getGlobalSettings()
          } else {
            this.anotherSettings = data.meta.settings;
            this.globalSettingsData = data.meta.settings;
            this.createGlobalSettingsForm()
          }
        } else {
          this.anotherSettings = data.meta.settings;
          this.globalSettingsData = data.meta.settings;
          this.createGlobalSettingsForm()
        }
      },
      (err) => {
        this._router.navigateByUrl('dashboard');
        this._snackBar.open(err.error.message, 'Undo', {
          duration: 3000
        })

      }
    );
  }

  isPeriodicToggleChange(event) {
    const ssScreenCaptureTimeControl = this.globalSettings.get('ss_screen_capture_time');
    if (!event.checked) {
      this.isPeriodic = true;
      ssScreenCaptureTimeControl.disable();
    } else {
      this.isPeriodic = false;
      ssScreenCaptureTimeControl.enable();
    }
  }
  isAppChangeToggleChange(event) {
    const ss_appchange_interval = this.globalSettings.get('ss_appchange_interval');
    if (!event.checked) {
      this.isAppChange = true;
      ss_appchange_interval.disable();
    } else {
      this.isAppChange = false;
      ss_appchange_interval.enable();
    }
  }
  isPersonalizesToggleChange(event) {
    const ssScreenCaptureTimeControl = this.globalSettings.get('ss_screen_capture_time');
    const ss_idle_time = this.globalSettings.get('ss_idle_time');
    const ss_auto_send_summry_time = this.globalSettings.get('ss_auto_send_summry_time');
    const ss_appchange_interval = this.globalSettings.get('ss_appchange_interval');

    const ss_image_messages_discord_url = this.globalSettings.get('ss_image_messages_discord_url');
    const ss_status_messages_discord_url = this.globalSettings.get('ss_status_messages_discord_url');
    const ss_summary_messages_discord_url = this.globalSettings.get('ss_summary_messages_discord_url');

    const ss_periodic = this.globalSettings.get('ss_periodic');
    const ss_appchange = this.globalSettings.get('ss_appchange');
    const ss_webcam = this.globalSettings.get('ss_webcam');
    const ss_silent = this.globalSettings.get('ss_silent');
    const ss_strict_time_tracking = this.globalSettings.get('ss_strict_time_tracking');
    const ss_automatic_tracking = this.globalSettings.get('ss_automatic_tracking');

    if (!event.checked) {
      this.isPersonalized = true;
      ssScreenCaptureTimeControl.disable();
      ss_idle_time.disable();
      ss_auto_send_summry_time.disable();
      ss_appchange_interval.disable();

      ss_image_messages_discord_url.disable();
      ss_status_messages_discord_url.disable();
      ss_summary_messages_discord_url.disable();

      ss_periodic.disable();
      ss_appchange.disable();
      ss_webcam.disable();
      ss_silent.disable();
      ss_strict_time_tracking.disable();
      ss_automatic_tracking.disable();

    } else {
      this.isPersonalized = false;
      if (this.isPeriodic) {
        ssScreenCaptureTimeControl.disable();
      } else {
        ssScreenCaptureTimeControl.enable();
      }
      if (this.isAppChange) {
        ss_appchange_interval.disable();
      } else {
        ss_appchange_interval.enable();
      }
      ss_idle_time.enable();
      ss_auto_send_summry_time.enable();

      ss_image_messages_discord_url.enable();
      ss_status_messages_discord_url.enable();
      ss_summary_messages_discord_url.enable();

      ss_periodic.enable();
      this.applyAdvancedScreenshotModeFieldLocks(true);
      ss_silent.enable();

      if (!ss_silent.value) {
        ss_strict_time_tracking.enable();
        ss_automatic_tracking.enable();
      }
    }

    if (this.isWebcamCaptureEntitled) {
      this.applyWebcamEntitlementToForm();
    } else {
      this.lockWebcamField();
    }
  }
  // FORM CONTROL

  createGlobalSettingsForm() {
    if (this.userId) {

      let setting = (this.globalSettingsData && this.globalSettingsData.ss_personalizeSettings !== undefined)
        ? this.globalSettingsData.ss_personalizeSettings.toLowerCase() == 'true'
        : false
      if (setting) {
        this.isPersonalized = false;
      } else {
        this.isPersonalized = true;
      }
    } else {
      this.isPersonalized = false;
    }

    let periodic = (this.globalSettingsData && this.globalSettingsData.ss_periodic !== undefined)
      ? this.globalSettingsData.ss_periodic.toLowerCase() == 'true'
      : false;
    if (periodic) {
      this.isPeriodic = false;
    } else {
      this.isPeriodic = true;
    }

    let appChange = (this.globalSettingsData && this.globalSettingsData.ss_appchange !== undefined)
      ? this.globalSettingsData.ss_appchange.toLowerCase() == 'true'
      : false;
    if (appChange) {
      this.isAppChange = false;
    } else {
      this.isAppChange = true;
    }

    let isSilent = (this.globalSettingsData && this.globalSettingsData.ss_silent !== undefined)
      ? this.globalSettingsData.ss_silent.toLowerCase() == 'true'
      : false;

    this.globalSettings = this.formBuilder.group({
      ss_screen_capture_time: new FormControl({
        value: (this.globalSettingsData && this.globalSettingsData.ss_screen_capture_time) ? this.globalSettingsData.ss_screen_capture_time : globalSettingsTime.ss_screen_capture_time,
        disabled: this.isPersonalized || this.isPeriodic,
      }, [this.timeValidator, time24FormatValidator()]),
      ss_idle_time: new FormControl({
        value: (this.globalSettingsData && this.globalSettingsData.ss_idle_time) ? this.globalSettingsData.ss_idle_time : globalSettingsTime.idle_time,
        disabled: this.isPersonalized
      }, [this.timeValidator, time24FormatValidator()]),
      ss_auto_send_summry_time: new FormControl({
        value: (this.globalSettingsData && this.globalSettingsData.ss_auto_send_summry_time) ? this.globalSettingsData.ss_auto_send_summry_time : '',
        disabled: this.isPersonalized
      }),
      ss_appchange_interval: new FormControl({
        value: (this.globalSettingsData && this.globalSettingsData.ss_appchange_interval) ? this.globalSettingsData.ss_appchange_interval : globalSettingsTime.ss_appchange_interval,
        disabled: this.isPersonalized || this.isAppChange
      }, [this.timeValidator, time24FormatValidator()]),

      ss_image_messages_discord_url: new FormControl({
        value: (this.globalSettingsData && this.globalSettingsData.ss_image_messages_discord_url) ? this.globalSettingsData.ss_image_messages_discord_url : '',
        disabled: this.isPersonalized
      }),
      ss_status_messages_discord_url: new FormControl({
        value: (this.globalSettingsData && this.globalSettingsData.ss_status_messages_discord_url) ? this.globalSettingsData.ss_status_messages_discord_url : '',
        disabled: this.isPersonalized
      }),
      ss_summary_messages_discord_url: new FormControl({
        value: (this.globalSettingsData && this.globalSettingsData.ss_summary_messages_discord_url) ? this.globalSettingsData.ss_summary_messages_discord_url : '',
        disabled: this.isPersonalized
      }),

      ss_periodic: new FormControl({
        value: (this.globalSettingsData && this.globalSettingsData.ss_periodic !== undefined)
          ? this.globalSettingsData.ss_periodic.toLowerCase() == 'true'
          : false,
        disabled: this.isPersonalized
      }
      ),
      ss_appchange: new FormControl({
        value:
          (this.globalSettingsData && this.globalSettingsData.ss_appchange !== undefined)
            ? this.globalSettingsData.ss_appchange.toLowerCase() == 'true'
            : false,
        disabled: this.isPersonalized
      }
      ),
      ss_webcam: new FormControl({
        value: this.parseSettingBoolean(this.globalSettingsData?.ss_webcam),
        disabled: this.isPersonalized || !this.isWebcamCaptureEntitled
      }),
      ss_silent: new FormControl(
        {
          value: (this.globalSettingsData && this.globalSettingsData.ss_silent !== undefined)
            ? this.globalSettingsData.ss_silent.toLowerCase() == 'true'
            : false,
          disabled: this.isPersonalized

        }
      ),
      ss_strict_time_tracking: new FormControl(
        {
          value: (this.globalSettingsData && this.globalSettingsData.ss_strict_time_tracking !== undefined)
            ? this.globalSettingsData.ss_strict_time_tracking.toLowerCase() == 'true'
            : true,
          disabled: this.isPersonalized || isSilent
        }
      ),
      ss_automatic_tracking: new FormControl(
        {
          value: (this.globalSettingsData && this.globalSettingsData.ss_automatic_tracking !== undefined)
            ? this.globalSettingsData.ss_automatic_tracking.toLowerCase() == 'true'
            : false,
          disabled: this.isPersonalized || isSilent
        }
      ),
      ss_personalizeSettings: new FormControl(
        (this.globalSettingsData && this.globalSettingsData.ss_personalizeSettings !== undefined)
          ? this.globalSettingsData.ss_personalizeSettings.toLowerCase() == 'true'
          : false
      ),
      summary_Interval: new FormControl('00:20:00'
      ),
      summary_Search: new FormControl('')
    })
    this.syncEntitlementsFromLatestUser();
    this.applyEntitlementFieldLocks();
    this.cdr.detectChanges();
  }

  private applyWebcamEntitlementToForm(): void {
    const ssWebcam = this.globalSettings?.get('ss_webcam');
    if (!ssWebcam) {
      return;
    }

    const personalizeValue = this.globalSettings.get('ss_personalizeSettings')?.value;
    const canEditPersonalizedSettings = !this.userId || personalizeValue === true || personalizeValue === 'true';
    const canEditWebcam = this.isWebcamCaptureEntitled && canEditPersonalizedSettings;
    if (ssWebcam.pristine) {
      this.paintWebcamFromBackend(ssWebcam);
    }
    if (canEditWebcam && ssWebcam.disabled) {
      ssWebcam.enable({ emitEvent: false });
    }
    if (!canEditWebcam && ssWebcam.enabled) {
      ssWebcam.disable({ emitEvent: false });
    }
  }

  /**
   * Settings often arrive before webcam assignment. A not-yet-known entitlement used to
   * write false into the toggle, then enable it later without putting the backend value back.
   * Re-apply that value while the admin has not edited the control.
   */
  private paintWebcamFromBackend(ctrl: AbstractControl): void {
    const backendValue = this.globalSettingsData?.ss_webcam;
    if (backendValue === undefined || backendValue === null) {
      return;
    }
    const webcamEnabled = this.parseSettingBoolean(backendValue);
    if (ctrl.disabled) {
      ctrl.enable({ emitEvent: false });
    }
    ctrl.setValue(webcamEnabled, { emitEvent: false });
    ctrl.markAsPristine({ onlySelf: true });
  }

  private trackingScope(): string {
    return this.userId ? 'This employee' : 'Employees using these company settings';
  }

  strictTimeWarning(event: any) {
    const who = this.trackingScope();
    if (!event.checked) {
      swal.fire({
        title: 'Strict Time Tracking is off',
        html: `<p>${who} can change the computer clock without being signed out.</p>` +
          '<div class="ss-impact"><strong>Important</strong>Tracked time can be less accurate if the clock is changed. Save Changes to apply this.</div>',
        confirmButtonText: 'Got it',
      })
    }
    else {
      swal.fire({
        title: 'Strict Time Tracking is on',
        html: `<p>${this.userId
          ? 'If this employee changes the computer clock, they are signed out.'
          : 'If an employee using these company settings changes the computer clock, they are signed out.'}</p>` +
          '<div class="ss-impact"><strong>Important</strong>Save Changes to apply this.</div>',
        confirmButtonText: 'Got it',
      })
    }
  }

  automaticTimeWarning(event: any) {
    const who = this.trackingScope();
    if (!event.checked) {
      swal.fire({
        title: 'Automatic Tracking is off',
        html: `<p>${who} can start, pause, and stop tracking, and can sign out.</p>` +
          '<div class="ss-impact"><strong>Important</strong>Save Changes to apply this.</div>',
        confirmButtonText: 'Got it',
      })
    }
    else {
      swal.fire({
        title: 'Automatic Tracking is on',
        html: `<p>${who} can't stop tracking, pause, or sign out.</p>` +
          '<div class="ss-impact"><strong>Important</strong>Save Changes to apply this.</div>',
        confirmButtonText: 'Got it',
      })
    }
  }

  silentModeToggleChange(event: any) {
    const strictControl = this.globalSettings.get('ss_strict_time_tracking');
    const autoControl = this.globalSettings.get('ss_automatic_tracking');

    if (event.checked) {
      strictControl.setValue(false);
      autoControl.setValue(false);
      strictControl.disable();
      autoControl.disable();

      swal.fire({
        title: 'Silent Mode is on',
        html: `<p>${this.userId
          ? 'This employee no longer has Strict Time Tracking or Auto Tracking. Those settings stay locked.'
          : 'Employees using these company settings no longer have Strict Time Tracking or Auto Tracking. Those settings stay locked.'}</p>` +
          '<div class="ss-impact"><strong>Important</strong>Save Changes to apply this. Turn Silent Mode off to change them again.</div>',
        confirmButtonText: 'Got it',
      });
    } else {
      if (!this.isPersonalized) {
        strictControl.enable();
        autoControl.enable();
      }
    }
  }

  // API CALL

  timeValidator(timeValue) {
    const value = timeValue.value;
    const [hours, minutes] = value.split(':').map(Number);
    const totalNumberOfMinutes = (hours * 60) + minutes;
    return totalNumberOfMinutes < 1 || value == '' ? { "invalidTime": true } : null;
  }

  // validator for 30 seconds
  secondValidator(timeValue) {
    const value = timeValue.value;
    const [hours, minutes, seconds] = value.split(':').map(Number);
    const totalNumberOfMinutes = (hours * 60 * 60) + (minutes * 60) + seconds;
    return totalNumberOfMinutes < 30 ? { "invalidTime": true } : null;
  }

  submitGlobalConfig(type) {
    if (type == "save" && this.activeTab == "bulk") {
      this.bulkUpdateSettingsComponent.submitBulkUpdate();
      return;
    }

    if (this.globalSettings.invalid) {
      this.globalSettings.markAllAsTouched()
      swal.fire({
        icon: 'error',
        title: 'Please Fill information validly.',
        timer: 2000,
        showConfirmButton: false,
      })
      return
    }


    if (!this.userId) {
      if (this.activeTab === 'delivery' && type === 'next') {
        this.saveReportRecipients();
        this.setActiveTab('capture');
        return;
      }
      if (this.activeTab === 'schedule' && type === 'next') {
        this.setActiveTab(this.showBulkUpdateTab() ? 'bulk' : 'delivery');
        return;
      }
    }


    const performSubmit = () => {
      this.clampScreenshotIntervalForSave();
      this.globalSettings.value.ss_screen_capture_time = !this.globalSettings.get('ss_screen_capture_time').disabled ? this.globalSettings.value.ss_screen_capture_time.split(":").length == 2 ? this.globalSettings.value.ss_screen_capture_time + ":00" : this.globalSettings.value.ss_screen_capture_time : '';
      this.globalSettings.value.ss_idle_time = !this.globalSettings.get('ss_idle_time').disabled ? this.globalSettings.value.ss_idle_time.split(":").length == 2 ? this.globalSettings.value.ss_idle_time + ":00" : this.globalSettings.value.ss_idle_time : '';
      this.globalSettings.value.ss_appchange_interval = !this.globalSettings.get('ss_appchange_interval').disabled ? this.globalSettings.value.ss_appchange_interval.split(":").length == 2 ? this.globalSettings.value.ss_appchange_interval + ":00" : this.globalSettings.value.ss_appchange_interval : '';
      let settingVal;
      const ssScreenCaptureTimeControl = this.globalSettings.get('ss_personalizeSettings');

      if (this.userId && ssScreenCaptureTimeControl.value == false || ssScreenCaptureTimeControl.value == 'false') {
        if (this.anotherSettings.ss_personalizeSettings) {
          this.anotherSettings['ss_personalizeSettings'] = 'false';
        }
        settingVal = this.anotherSettings;
        settingVal['ss_webcam'] = false;
      } else {
        settingVal = this.globalSettings.getRawValue();

        if (this.isAppChange) {
          settingVal['ss_appchange_interval'] = this.globalSettings.value.ss_appchange_interval ? this.globalSettings.value.ss_appchange_interval : this.anotherSettings.ss_appchange_interval ? this.anotherSettings.ss_appchange_interval : '';
        }
        if (this.isPeriodic) {
          settingVal['ss_screen_capture_time'] = this.globalSettings.value.ss_screen_capture_time ? this.globalSettings.value.ss_screen_capture_time : this.anotherSettings.ss_screen_capture_time ? this.anotherSettings.ss_screen_capture_time : '';
        }
      }

      settingVal = this.applySettingsEntitlementPayloadRules(settingVal);

      this._projectService.setGlobalSettings(settingVal, this.userId).subscribe((res: any) => {

        if (this.userId) {
          this.getUserDetails();
          this._snackBar.open(`${this.userName} Personalize Settings for ${this.activeUserTab} updated successfully`, 'Close', { duration: 3000 });
          if (type == 'next') {
            switch (this.activeUserTab) {
              case 'capture':
                this.setActiveUserTab('tracking');
                break;
              case 'tracking':
                this.setActiveUserTab('capture');
                break;
            }
          }
        } else {
          this.getGlobalSettings()
          this._snackBar.open(`Global Settings for ${this.activeTab} updated successfully`, 'Close', { duration: 3000 });
          if (type == 'next') {
            switch (this.activeTab) {
              case 'capture':
                this.setActiveTab('tracking');
                break;
              case 'tracking':
                this.setActiveTab('schedule');
                break;
              case 'schedule':
                this.setActiveTab(this.showBulkUpdateTab() ? 'bulk' : 'delivery');
                break;
              case 'bulk':
                this.setActiveTab('delivery');
                break;
              case 'delivery':
                this.setActiveTab('capture');
                break;
            }
          }
        }
      }, error => {
        swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.error.message,
          timer: 2000,
          showConfirmButton: false,
        })
      })
    };

    const isMobileFlow = this.deviceDetectionService.isMobileOrTablet();
    const verificationContext = this.phoneVerificationService.getCompanyVerificationContext(
      this.tokenEncryptionService.getEncryptedItem<any>('user')
    );

    console.log('[UserSettingPanel][PhoneVerificationGate]', {
      flow: isMobileFlow ? 'mobile/tablet' : 'desktop',
      quotaStatus: verificationContext.quotaStatus,
      isTrialCompany: verificationContext.isTrialCompany,
      isLocallyVerified: verificationContext.isLocallyVerified,
      isMetaVerified: verificationContext.isMetaVerified,
      isPhoneVerified: verificationContext.isPhoneVerified,
      shouldRequireVerification: verificationContext.shouldRequireVerification
    });

    console.log('[UserSettingPanel][PhoneVerificationGate] Proceeding without verification popup', {
      flow: isMobileFlow ? 'mobile/tablet' : 'desktop',
      reason: 'product settings no longer require phone OTP'
    });

    if (this.activeTab !== 'delivery') {
      performSubmit();
    }
  }

  resetBulkSettings() {
    this.bulkUpdateSettingsComponent.resetSettings();
  }

  getGlobalSettings() {
    this._projectService.getGlobalSettings().subscribe((res: any) => {
      const settings = (res && res.data) ? res.data : res;
      this.tokenEncryptionService.setEncryptedItem('globalSettings', settings);
      this.globalSettingsData = settings;
      this.anotherSettings = settings;
      this.createGlobalSettingsForm()
    })
  }

  getUSer() {
    let roleArr = [];
    this.userService.clearOnlyCache();
    this._projectService.getUser().subscribe((data: any) => {
      this.id = data.id;
      this.phoneVerificationService.syncVerificationStatusFromUserMeta(data);
      const recipientsMails = this._sharedServices.updateTheRecipientsMail('get');
      this.tokenEncryptionService.setEncryptedItem('user', data);
      this.isWebcamCaptureEntitled = this._projectService.isEntitlementEnabled(data, EntitlementKey.webcam_capture);
      this.loadSettingsAddOns(data);
      this.userService.setCurrentUser(data);
      this.entitlementsService.syncFromUser(data);
      this.refreshScreenshotIntervalFloor();
      this.applyEntitlementFieldLocks();
      if (this.globalSettings) {
        this.cdr.detectChanges();
      }
      let isExpired = this._sharedServices.checkPlanExpired(data)
      if (isExpired) {
        return this._router.navigateByUrl('/plan-expired');
      }
      roleArr = data.role;
      let quota_Status = data.meta.quota_status;
      if (quota_Status == 'active' || quota_Status == 'Active' || quota_Status == 'trial' || quota_Status == 'Trial') {
        this.quotaStatus = 'active';
        if (data.meta.expires_at) {
          let day_left = this.getRemainingDate(data.meta.expires_at)
          if (day_left < 0) {
            this.quotaStatus = 'expired';
          }
        }
      }
      if (quota_Status == 'trial-expired' || quota_Status == 'Trial-expired' || quota_Status == 'expired' || quota_Status == 'Expired') {
        this.quotaStatus = 'expired';
      }
      if (data.meta.expires_at) {
        this.quota_expired_date = this.formattedDate(data.meta.expires_at);
      }
      this.totalUser = data.meta.quota_allowed < 0 ? 0 : data.meta.quota_allowed;
      this.availableUser = data.meta.quota_remaining == 'false' || data.meta.quota_remaining == false ? 0 : data.meta.quota_remaining;
      this.useUser = (data.meta.quota_allowed - this.availableUser) < 0 ? 0 : (data.meta.quota_allowed - this.availableUser)
      this.availableUser = this.availableUser < 0 ? 0 : this.availableUser;

      let adminRole = roleArr.filter((ele) => {
        return (ele.toLowerCase().includes("admin") || ele.toLowerCase().includes("company"));
      })
      if (adminRole.length == 0) {
        this.isAdmin = false;
      } else {
        this.isAdmin = true;
      }

      // Load shifts and employees once company ID is available
      this.loadShifts();
      this.loadShiftEmployees();

      // Load report recipient emails for admin users
      if (this.isAdmin && recipientsMails) {
        if (Array.isArray(recipientsMails)) {
          this.reportRecipientEmails = recipientsMails;
        } else if (typeof recipientsMails === 'string') {
          this.reportRecipientEmails = recipientsMails.split(',').map(email => email.trim()).filter(email => email.length > 0);
        } else {
          this.reportRecipientEmails = [];
        }
      } else {
        this.reportRecipientEmails = [];
      }

      if (this.isAdmin) {
        const countryHint = data?.meta?.rao_phone_country || data?.meta?.billing_country || data?.meta?.country;
        this.whatsappDialCode = this.contactPhoneCapture.dialCodeForCountry(countryHint);
        this.workspacePhone = this.contactPhoneCapture.toE164(data?.meta?.phone_number, countryHint);
        this.whatsappOptedIn = String(data?.meta?.ss_whatsapp_daily_opted_in) === '1';
        this.whatsappNumbers = this.contactPhoneCapture.parseDailyNumbers(data?.meta?.ss_whatsapp_daily_numbers);
        if (this.workspacePhone) {
          const savedParts = this.contactPhoneCapture.parsePhoneParts(this.workspacePhone);
          this.whatsappDialCode = savedParts.dialCode || this.whatsappDialCode;
        }
        if (this.whatsappOptedIn && this.includeWorkspacePhoneInList()) {
          this.persistWhatsappMeta(false);
        }
        this.captureDeliverySnapshot();
      } else {
        this.workspacePhone = '';
        this.whatsappOptedIn = false;
        this.whatsappNumbers = [];
        this.captureDeliverySnapshot();
      }
    })
  }

  isTourActive() {
    if (localStorage.getItem('isTour')) {
      if (localStorage.getItem('isTour') == 'false') {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  formattedDate(expiresAt): string {
    const parsedDate = new Date(expiresAt);
    const formattedDate = this.datePipe.transform(parsedDate, 'dd MMM, yyyy');

    return formattedDate || '';
  }
  getRemainingDate(strDate) {
    const expirationDate = new Date(strDate);
    const timeDifference = expirationDate.getTime() - new Date().getTime();
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    let daysRemaining = Math.round(daysDifference);
    return daysRemaining;
  }

  loadShifts(deletedShiftId?: number): void {
    if (deletedShiftId) {
      this.shifts = this.shifts.filter(s => Number(s.id) !== Number(deletedShiftId));
      this.cdr.detectChanges();
    }

    this.userService.fetchCurrentUser().subscribe({
      next: (user) => {
        const companyId = user?.id;
        if (!companyId) {
          this.isLoadingShifts = false;
          return;
        }
        // Cache buster to bypass strict API caches
        const cacheBuster = `?_t=${new Date().getTime()}`;
        this.shiftService.getShifts(companyId, cacheBuster).subscribe({
          next: (shifts) => {
            if (deletedShiftId) {
              shifts = shifts.filter(s => Number(s.id) !== Number(deletedShiftId));
            }
            this.shifts = shifts;
            this.shiftLimitReached = this.entitlementsService.isShiftLimitReached(shifts.length);
            this.isLoadingShifts = false;
            this.cdr.detectChanges();
          },
          error: (error) => {
            this.isLoadingShifts = false;
            this.cdr.detectChanges();
          }
        });
      },
      error: () => {
        this.isLoadingShifts = false;
      }
    });
  }

  loadShiftEmployees(): void {
    if (this.shiftEmployees.length > 0) return;
    this._projectService.getUserList(0, 100, true).subscribe({
      next: (users: any) => {
        const list = Array.isArray(users) ? users : users?.data ?? [];
        this.shiftEmployees = list.map(u => ({ id: u.id, name: u.name || u.slug || String(u.id) }));
      },
      error: () => {
        this.shiftEmployees = [];
      }
    });
  }

  onShiftCreated(formData: any): void {
    if (this.isSubmittingShift) return;
    this.isSubmittingShift = true;
    this._submitShift(formData);
  }

  editShift(shift: Shift): void {
    this.editingShift = shift;
    this.isEditMode = true;
    this.showShiftDrawer = true;
  }

  closeShiftDrawer(): void {
    this.showShiftDrawer = false;
    this.editingShift = null;
    this.isEditMode = false;
  }

  onShiftUpdated(formData: any): void {
    if (this.isSubmittingShift) return;
    this.isSubmittingShift = true;
    this._submitShiftUpdate(formData);
  }

  private _submitShift(formData: any): void {
    if (this.entitlementsService.isShiftLimitReached(this.shifts.length)) {
      this.shiftLimitReached = true;
      this.showShiftDrawer = false;
      this._snackBar.open(
        'Multiple shifts are included on Professional and Business plans.',
        'Close',
        { duration: 5000 }
      );
      return;
    }

    const payload: ShiftPayload = {
      shift_name: formData.shift_name,
      timezone: formData.timezone,
      shift_start_time: formData.start_time,
      shift_end_time: formData.end_time,
      working_days: formData.working_days,
      is_overnight: formData.is_overnight,
      // buffer_start_minutes: formData.buffer_start_minutes ?? 0,
      // buffer_end_minutes: formData.buffer_end_minutes ?? 0,
      strict_window: formData.strict_window ?? false,
      employee_ids: formData.employee_ids ?? [],
    };

    this.shiftService.createShift(payload).subscribe({
      next: (response) => {
        const shiftName = response?.shift_name || formData.shift_name;
        this.upsertShift(this.buildShiftFromForm(response?.shift_id, response?.company_id, formData, response), true);
        this._snackBar.open(`Shift "${shiftName}" created successfully!`, 'Close', { duration: 3000 });
        this.showShiftDrawer = false;
        this.isSubmittingShift = false;
        this.shiftEmployees = [];
        this.loadShiftEmployees();
        this.loadShifts();
      },
      error: (error) => {
        this._snackBar.open(error.message || 'Failed to create shift', 'Close', { duration: 5000 });
        this.isSubmittingShift = false;
        if (error.message?.includes('Only one shift is allowed')) {
          this.shiftLimitReached = true;
          this.showShiftDrawer = false;
        }
      }
    });
  }

  private _submitShiftUpdate(formData: any): void {
    if (!this.editingShift) return;

    const payload: ShiftPayload = {
      shift_name: formData.shift_name,
      timezone: formData.timezone,
      shift_start_time: formData.start_time,
      shift_end_time: formData.end_time,
      working_days: formData.working_days,
      is_overnight: formData.is_overnight,
      // buffer_start_minutes: formData.buffer_start_minutes ?? 0,
      // buffer_end_minutes: formData.buffer_end_minutes ?? 0,
      strict_window: formData.strict_window ?? false,
      employee_ids: formData.employee_ids ?? [],
    };

    const shiftId = this.editingShift.id;
    const employeeIds: number[] = formData.employee_ids ?? [];

    this.shiftService.updateShift(shiftId, payload).pipe(
      switchMap((response) => {
        return this.shiftService.updateShiftEmployees(shiftId, employeeIds).pipe(
          map(() => response)
        );
      })
    ).subscribe({
      next: (response: any) => {
        const shiftName = response?.shift_name || formData.shift_name;
        this.upsertShift({
          ...this.buildShiftFromForm(shiftId, response?.company_id ?? this.editingShift?.company_id, formData, response),
          created_at: response?.created_at ?? this.editingShift?.created_at,
          updated_at: response?.updated_at,
        });
        this._snackBar.open(`Shift "${shiftName}" updated successfully!`, 'Close', { duration: 3000 });
        this.closeShiftDrawer();
        this.isSubmittingShift = false;
        this.shiftEmployees = [];
        this.loadShiftEmployees();
        this.loadShifts();
      },
      error: (error) => {
        this._snackBar.open(error.message || 'Failed to update shift', 'Close', { duration: 5000 });
        this.isSubmittingShift = false;
      }
    });
  }

  private buildShiftFromForm(shiftId: number, companyId: number, formData: any, response?: any): Shift {
    const employeeIds = formData.employee_ids ?? response?.employee_ids ?? [];
    return {
      id: Number(shiftId),
      company_id: Number(companyId),
      shift_name: response?.shift_name ?? formData.shift_name,
      timezone: response?.timezone ?? formData.timezone,
      start_time: response?.start_time ?? response?.shift_start_time ?? formData.start_time,
      end_time: response?.end_time ?? response?.shift_end_time ?? formData.end_time,
      working_days: response?.working_days ?? formData.working_days ?? [],
      is_overnight: response?.is_overnight ?? formData.is_overnight,
      buffer_start_minutes: response?.buffer_start_minutes ?? formData.buffer_start_minutes ?? 0,
      buffer_end_minutes: response?.buffer_end_minutes ?? formData.buffer_end_minutes ?? 0,
      strict_window: response?.strict_window ?? formData.strict_window ?? false,
      status: response?.status ?? 'active',
      is_active: response?.is_active !== false,
      employee_ids: employeeIds,
      employee_count: response?.employee_count ?? employeeIds.length,
      employees: response?.employees ?? [],
      created_at: response?.created_at,
      updated_at: response?.updated_at,
    };
  }

  private upsertShift(shift: Shift, prepend = false): void {
    if (!shift?.id) return;
    const index = this.shifts.findIndex(item => Number(item.id) === Number(shift.id));
    if (index === -1) {
      this.shifts = prepend ? [shift, ...this.shifts] : [...this.shifts, shift];
      return;
    }
    this.shifts = this.shifts.map((item, i) => i === index ? { ...item, ...shift } : item);
  }

  /** Sticky save dock — only when the active tab has something to commit. */
  get showSettingsSaveDock(): boolean {
    if (this.activeTab === 'schedule') {
      return false;
    }
    if (this.activeTab === 'bulk') {
      return this.isBulkDirty;
    }
    if (this.activeTab === 'delivery') {
      return this.isDeliveryDirty;
    }
    return !!this.globalSettings?.dirty;
  }

  get canSettingsSave(): boolean {
    if (this.activeTab === 'bulk') {
      return this.bulkUpdateSettingsComponent?.isUpdateButtonEnabled() ?? false;
    }
    if (this.activeTab === 'delivery') {
      return this.isDeliveryDirty;
    }
    return !!this.globalSettings?.dirty && !this.globalSettings?.invalid;
  }

  get settingsSaveLabel(): string {
    if (this.activeTab === 'bulk') {
      const n = this.bulkUpdateSettingsComponent?.getSelectedCount() ?? 0;
      return n > 0 ? `Apply to ${n}` : 'Apply';
    }
    return 'Save';
  }

  get settingsSaveStatus(): string {
    if (this.activeTab === 'bulk') {
      const n = this.bulkUpdateSettingsComponent?.getSelectedCount() ?? 0;
      if (n === 0) {
        return 'Select people or teams to apply these settings';
      }
      return `Apply capture & tracking to ${n} selected`;
    }
    if (this.activeTab === 'delivery') {
      return 'Unsaved delivery changes';
    }
    return 'Unsaved changes';
  }

  get isDeliveryDirty(): boolean {
    return this.whatsappOptedIn !== this.initialWhatsappOptedIn
      || !this.sameStringLists(this.reportRecipientEmails, this.initialDeliveryEmails)
      || !this.sameStringLists(this.whatsappNumbers, this.initialWhatsappNumbers);
  }

  get isBulkDirty(): boolean {
    return !!this.bulkUpdateSettingsComponent?.isDirty;
  }

  get showEmployeeSaveDock(): boolean {
    return !!this.globalSettings?.dirty;
  }

  onSettingsSave(): void {
    if (this.activeTab === 'delivery') {
      this.saveReportRecipients();
      this.saveWhatsappNumbers();
      return;
    }
    this.submitGlobalConfig('save');
  }

  private captureDeliverySnapshot(): void {
    this.initialDeliveryEmails = [...this.reportRecipientEmails];
    this.initialWhatsappNumbers = [...this.whatsappNumbers];
    this.initialWhatsappOptedIn = this.whatsappOptedIn;
  }

  private sameStringLists(a: string[], b: string[]): boolean {
    if (a.length !== b.length) {
      return false;
    }
    return a.every((value, index) => value === b[index]);
  }

  // Report Recipients Email methods
  saveReportRecipients() {
    // Convert array to CSV string
    const csvEmails = this.reportRecipientEmails.join(',');

    let userData = {
      meta: {
        report_recipient_emails: csvEmails
      }
    };

    this._projectService.updateOwnSettings(this.id, userData).subscribe(
      (response) => {
        this._snackBar.open('Report recipients saved successfully!', 'Close', { duration: 3000 });
        this._sharedServices.updateTheRecipientsMail('update', csvEmails);
        // Update local storage with new data
        let user = this.tokenEncryptionService.getEncryptedItem<any>('user');
        if (user) {
          user.meta.report_recipient_emails = csvEmails;
          this.tokenEncryptionService.setEncryptedItem('user', user);
        }
        this.initialDeliveryEmails = [...this.reportRecipientEmails];
      },
      (error) => {
        this._snackBar.open('Failed to update report recipients.', 'Close', { duration: 3000 });
      }
    );
  }

  get whatsappDialDisplay(): string {
    const match = this.whatsappCountries.find((c) => c.dialCode === this.whatsappDialCode);
    if (match) {
      return `${match.code} ${match.dialCode}`;
    }
    return this.whatsappDialCode || '+91';
  }

  get canAddWhatsappNumber(): boolean {
    return this.whatsappNational.trim().length > 0
      && this.whatsappNumbers.length < this.maxWhatsappNumbers;
  }

  onWhatsappDialChange(dial: string): void {
    this.whatsappDialCode = this.contactPhoneCapture.normalizeDialCode(dial);
  }

  onWhatsappOptInChange(checked: boolean): void {
    this.whatsappOptedIn = checked;
    if (checked) {
      this.includeWorkspacePhoneInList();
    }
  }

  addWhatsappFromPicker(): void {
    const e164 = this.contactPhoneCapture.composeE164(this.whatsappDialCode, this.whatsappNational);
    if (!this.whatsappNational.trim()) {
      this._snackBar.open('Enter a mobile number.', 'Close', { duration: 2500 });
      return;
    }
    if (!this.addWhatsappNumberToList(e164)) {
      return;
    }
    this.whatsappNational = '';
  }

  private includeWorkspacePhoneInList(): boolean {
    if (!this.workspacePhone) {
      return false;
    }
    if (this.whatsappNumbers.includes(this.workspacePhone)) {
      return false;
    }
    if (this.whatsappNumbers.length >= this.maxWhatsappNumbers) {
      return false;
    }
    this.whatsappNumbers = [this.workspacePhone, ...this.whatsappNumbers];
    return true;
  }

  private addWhatsappNumberToList(number: string): boolean {
    const normalized = this.contactPhoneCapture.toE164(number);
    if (!normalized) {
      this._snackBar.open('Please enter a valid WhatsApp number.', 'Close', {
        duration: 3500,
      });
      return false;
    }
    if (this.whatsappNumbers.length >= this.maxWhatsappNumbers) {
      this._snackBar.open(`Maximum ${this.maxWhatsappNumbers} WhatsApp numbers allowed.`, 'Close', {
        duration: 3000,
      });
      return false;
    }
    if (this.whatsappNumbers.includes(normalized)) {
      this._snackBar.open('That WhatsApp number is already added.', 'Close', { duration: 3000 });
      return false;
    }
    this.whatsappNumbers = [...this.whatsappNumbers, normalized];
    return true;
  }

  removeWhatsappNumber(index: number): void {
    this.whatsappNumbers = this.whatsappNumbers.filter((_, i) => i !== index);
  }

  saveWhatsappNumbers(): void {
    if (this.whatsappNational.trim()) {
      const e164 = this.contactPhoneCapture.composeE164(this.whatsappDialCode, this.whatsappNational);
      if (!this.addWhatsappNumberToList(e164)) {
        return;
      }
      this.whatsappNational = '';
    }
    this.persistWhatsappMeta(true);
  }

  private persistWhatsappMeta(showSnackbar: boolean): void {
    if (!this.id || this.whatsappSeedWriteInFlight) {
      return;
    }
    this.whatsappSeedWriteInFlight = true;
    const userData = {
      meta: {
        ss_whatsapp_daily_opted_in: this.whatsappOptedIn ? '1' : '0',
        ss_whatsapp_daily_numbers: JSON.stringify(this.whatsappNumbers),
      },
    };

    this._projectService.updateOwnSettings(this.id, userData).subscribe(
      () => {
        this.whatsappSeedWriteInFlight = false;
        const user = this.tokenEncryptionService.getEncryptedItem<any>('user');
        if (user) {
          if (!user.meta) {
            user.meta = {};
          }
          user.meta.ss_whatsapp_daily_opted_in = this.whatsappOptedIn ? '1' : '0';
          user.meta.ss_whatsapp_daily_numbers = JSON.stringify(this.whatsappNumbers);
          this.tokenEncryptionService.setEncryptedItem('user', user);
        }
        this.initialWhatsappNumbers = [...this.whatsappNumbers];
        this.initialWhatsappOptedIn = this.whatsappOptedIn;
        if (showSnackbar) {
          this._snackBar.open('WhatsApp numbers saved successfully!', 'Close', { duration: 3000 });
        }
      },
      () => {
        this.whatsappSeedWriteInFlight = false;
        if (showSnackbar) {
          this._snackBar.open('Failed to update WhatsApp numbers.', 'Close', { duration: 3000 });
        }
      }
    );
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';

    if (pastedData.trim()) {
      this.processMultipleEmails(pastedData);
    }
  }

  addEmailFromInput(input: HTMLInputElement): void {
    const value = input.value.trim();

    if (value && this.isValidEmail(value)) {
      this.addEmailToList(value);
      input.value = '';
      this.emailInputControl.setValue('');
    }
  }

  private addEmailToList(email: string): void {
    if (this.reportRecipientEmails.length >= this.maxEmails) {
      this._snackBar.open(`Maximum ${this.maxEmails} email addresses allowed.`, 'Close', { duration: 3000 });
      return;
    }

    if (this.reportRecipientEmails.indexOf(email) === -1) {
      this.reportRecipientEmails.push(email);
    } else {
      this._snackBar.open('Email address already added.', 'Close', { duration: 3000 });
    }
  }

  removeEmail(index: number): void {
    if (index >= 0 && index < this.reportRecipientEmails.length) {
      this.reportRecipientEmails.splice(index, 1);
    }
  }

  private processMultipleEmails(input: string): void {
    // Split by various delimiters: comma, semicolon, space, newline, tab
    const emails = input
      .split(/[,;\s\n\t]+/)
      .map(email => email.trim())
      .filter(email => email.length > 0);

    let addedCount = 0;
    let duplicateCount = 0;
    let invalidCount = 0;

    emails.forEach(email => {
      if (this.reportRecipientEmails.length >= this.maxEmails) {
        return; // Stop if we've reached the limit
      }

      if (this.isValidEmailSilent(email)) {
        if (this.reportRecipientEmails.indexOf(email) === -1) {
          this.reportRecipientEmails.push(email);
          addedCount++;
        } else {
          duplicateCount++;
        }
      } else {
        invalidCount++;
      }
    });

    // Show feedback message
    let message = '';
    if (addedCount > 0) {
      message += `${addedCount} email(s) added. `;
    }
    if (invalidCount > 0) {
      message += `${invalidCount} invalid email(s) skipped. `;
    }
    if (duplicateCount > 0) {
      message += `${duplicateCount} duplicate(s) skipped. `;
    }
    if (this.reportRecipientEmails.length >= this.maxEmails) {
      message += `Maximum ${this.maxEmails} emails limit reached.`;
    }

    if (message) {
      this._snackBar.open(message.trim(), 'Close', { duration: 4000 });
    }
  }

  private isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  private isValidEmailSilent(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  viewDemoReport() {
    // Open demo report in a modal
    this.dialog.open(DemoReportModalComponent, {
      panelClass: 'demo-report-dialog',
      width: '900px',
      maxWidth: '95vw',
      height: '90vh',
      maxHeight: '95vh',
      disableClose: false,
    });
  }

  private handleIframeMessage(event: MessageEvent) {
    // Check if the message is from our iframe and contains the navigation command
    if (event.data === 'navigateToDashboard') {
      this.navigateToDashboard();
    }

    if (event.data === 'navigateToCompanyWebsite') {
      this.navigateToCompanyWebsite();
    }
  }

  private navigateToDashboard() {
    this._router.navigate(['/dashboard']);
  }

  private navigateToCompanyWebsite() {
    window.open('https://www.raoinformationtechnology.com', '_blank');
  }

  getMinutesFromTime(timeStr: string): string {
    if (!timeStr || timeStr === '' || timeStr === 'undefined') return '15';
    try {
      const parts = timeStr.split(':');
      if (parts.length >= 2) {
        const hours = parseInt(parts[0]) || 0;
        const minutes = parseInt(parts[1]) || 0;
        return ((hours * 60) + minutes).toString();
      }
      return '15';
    } catch (e) {
      return '15';
    }
  }

  // Helpers for stepper controls in Interval Settings
  private minutesToHHMMSS(totalMinutes: number): string {
    const safeMinutes = Math.max(1, Math.floor(totalMinutes));
    const hours = Math.floor(safeMinutes / 60);
    const minutes = safeMinutes % 60;
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(hours)}:${pad(minutes)}:00`;
  }

  private getMinutes(controlName: string, fallback: number): number {
    try {
      const ctrl = this.globalSettings?.get(controlName);
      const value = ctrl?.value as string;
      const str = this.getMinutesFromTime(value);
      const parsed = parseInt(str, 10);
      return isNaN(parsed) ? fallback : parsed;
    } catch {
      return fallback;
    }
  }

  readonly entitlementKeys = EntitlementKey;

  canBulkSettingsUpdate(): boolean {
    return this.entitlementsService.hasCompany(EntitlementKey.bulk_settings_update);
  }

  showBulkUpdateTab(): boolean {
    return (this.isAdmin || this.isManager)
      && (this.canBulkSettingsUpdate() || this.entitlementsService.isEnforcementActive());
  }

  isSettingsFeatureLocked(key: string): boolean {
    return this.entitlementsService.isCompanyLocked(key);
  }

  setActiveTab(tab: string, entitlementKey: string | null = null): void {
    const section = this.resolveSection(tab);
    if (entitlementKey && this.isSettingsFeatureLocked(entitlementKey)) {
      void this._router.navigate(['/feature-locked'], {
        queryParams: { keys: entitlementKey, returnUrl: '/employee/setting' },
      });
      return;
    }
    this.activeTab = section;
    this.updateUrlTab(section);
    if (section === 'delivery') {
      this.checkConductIntegrationStatus();
    }
  }

  setActiveUserTab(tab: string) {
    this.activeUserTab = this.resolveUserSection(tab);
    this.updateUrlTab(this.activeUserTab);
  }

  updateUrlTab(tab: string) {
    this._router.navigate([], {
      relativeTo: this._route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  canMultipleShifts(): boolean {
    return this.entitlementsService.hasCompany(EntitlementKey.multiple_shifts);
  }

  canAdvancedTrackingControls(): boolean {
    return this.entitlementsService.hasCompany(EntitlementKey.advanced_tracking_controls);
  }

  canShortScreenshotInterval(): boolean {
    return this.entitlementsService.hasShortScreenshotIntervalEntitlement();
  }

  canAdvancedScreenshotModes(): boolean {
    return this.entitlementsService.canUseAdvancedScreenshotModes();
  }

  isWebcamEnabled(): boolean {
    const ctrl = this.globalSettings?.get('ss_webcam');
    if (ctrl) {
      return this.parseSettingBoolean(ctrl.value);
    }
    return this.parseSettingBoolean(this.globalSettingsData?.ss_webcam);
  }

  advancedScreenshotModesUpgradeMessage(): string {
    return this.entitlementsService.advancedScreenshotModesUpgradeMessage();
  }

  planRetentionSummaryLabel(): string {
    return `Your plan retains screenshots for ${this.entitlementsService.getScreenshotsRetentionDays()} days and activity logs for ${this.entitlementsService.getLogsRetentionDays()} days.`;
  }

  showPlanRetentionSummary(): boolean {
    return this.entitlementsService.isEnforcementActive();
  }

  private getLatestUser(): any {
    return this.userService.getCurrentUserValue()
      ?? this.tokenEncryptionService.getEncryptedItem('user');
  }

  private syncEntitlementsFromLatestUser(): void {
    const user = this.getLatestUser();
    this.entitlementsService.syncFromUser(user);
    this.refreshScreenshotIntervalFloor();
  }

  private refreshScreenshotIntervalFloor(): void {
    const user = this.getLatestUser();
    const hasShortInterval = this.entitlementsService.hasShortScreenshotIntervalEntitlement();
    const addon = this.getCompanyAddOn('custom_periodic_interval');

    // 1. Determine base floor from company add-on limits or user limits
    let baseFloor = this.companyAddOnLimits?.screenshot_interval_min_minutes !== undefined
      ? Number(this.companyAddOnLimits.screenshot_interval_min_minutes)
      : resolveScreenshotIntervalFloorMinutes(user, false);

    let floor = baseFloor;

    // 2. Apply short interval entitlement (legacy Professional plan capability)
    // if (hasShortInterval) {
    //   floor = 1;
    //   // The custom periodic interval add-on gates the lowered screenshot interval.
    //   // When it is enabled but not applicable here (company-wide page or an employee
    //   // outside its user list), ignore both the merged override and the short-interval
    //   // capability it grants, and fall back to the standard plan minimum so the lower
    //   // interval does not leak to unassigned scopes.
    // }

    if (addon?.enabled && !this.isCustomIntervalAddonInScope(addon)) {
      this.screenshotCaptureMinMinutes = resolveScreenshotIntervalFloorMinutes(user, false);
      return;
    }

    const addOnLimitMinutes = this.settingsEntitlementsService.getAddOnLimitMinutes(addon);
    if (addon?.enabled && this.isCustomIntervalAddonInScope(addon) && addOnLimitMinutes !== null) {
      this.screenshotCaptureMinMinutes = addOnLimitMinutes;
      return;
    }

    // 3. Apply custom_periodic_interval add-on logic
    if (addon?.enabled) {
      if (this.isCustomIntervalAddonInScope(addon)) {
        // Apply the specific add-on config limit
        const addonLimit = addon.config?.limit_minutes;
        if (addonLimit !== undefined && addonLimit !== null) {
          floor = Number(addonLimit);
        }
      } else {
        // If the add-on is enabled but NOT in scope for this user/page,
        // we must ignore the add-on AND the short interval capability it might grant.
        // Fall back strictly to the base company limit.
        floor = baseFloor;
      }
    }

    this.screenshotCaptureMinMinutes = Math.max(1, floor);
  }

  private isCustomIntervalAddonInScope(addon: CompanyAddOnEntitlement): boolean {
    if (this.userId) {
      const effective = this.settingsEntitlementsService.buildEmployeeEffectiveEntitlements(
        this.companyAddOns,
        this.userId
      );
      return Boolean(effective['custom_periodic_interval']?.enabled);
    }
    return addon.assignment_mode === 'company' || addon.assignment_mode === 'all_users';
  }

  minScreenshotCaptureMinutes(): number {
    return this.screenshotCaptureMinMinutes;
  }

  screenshotIntervalPlanHint(): string {
    if (this.entitlementsService.hasShortScreenshotIntervalEntitlement()) {
      return '';
    }
    const min = this.screenshotCaptureMinMinutes;
    if (min <= 1) {
      return '';
    }
    return `Minimum ${min} minutes on your plan (Professional allows 10 minutes).`;
  }

  isScreenshotIntervalDecrementDisabled(): boolean {
    this.refreshScreenshotIntervalFloor();
    return this.getDisplayMinutes('ss_screen_capture_time', 15) <= this.screenshotCaptureMinMinutes;
  }

  decrementScreenshotInterval(event: Event): void {
    if (this.isScreenshotIntervalDecrementDisabled()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    this.incrementMinutes('ss_screen_capture_time', -1);
  }

  get shiftLimitTooltip(): string {
    if (!this.canMultipleShifts()) {
      return 'Multiple shifts are included on Professional and Business plans.';
    }
    if (this.shiftLimitReached) {
      return 'Only one shift is allowed currently.';
    }
    return '';
  }

  applyEntitlementFieldLocks(): void {
    this.refreshScreenshotIntervalFloor();
    if (!this.globalSettings) {
      return;
    }
    if (!this.canAdvancedTrackingControls()) {
      ['ss_strict_time_tracking', 'ss_automatic_tracking'].forEach((key) => {
        const ctrl = this.globalSettings.get(key);
        if (ctrl) {
          ctrl.setValue(false);
          ctrl.disable();
        }
      });
    }
    if (this.isWebcamCaptureEntitled) {
      this.applyWebcamEntitlementToForm();
    } else {
      this.lockWebcamField();
    }
    this.applyAdvancedScreenshotModeFieldLocks(!this.isPersonalized);
  }

  private loadSettingsAddOns(user: any = this.tokenEncryptionService.getEncryptedItem<any>('user')): void {
    const companyId = this.resolveCompanyId(user);
    if (!companyId) {
      this.webcamEntitlementKnown = true;
      this.applyEntitlementFieldLocks();
      return;
    }

    this.settingsEntitlementsService.getCompanyAddOnEntitlements(companyId).subscribe({
      next: (response) => {
        this.companyAddOns = response.assigned_addons ?? response.addons ?? [];
        this.companyAddOnLimits = response.limits ?? {};
        this.addOnStateMessage = '';
        this.syncSettingsAddOnApplicability();
        this.webcamEntitlementKnown = true;
        this.applyEntitlementFieldLocks();
        if (this.globalSettings) {
          this.cdr.detectChanges();
        }
      },
      error: (error) => {
        this.webcamEntitlementKnown = true;
        this.addOnStateMessage = error?.error?.message || 'Unable to load add-on assignment state.';
        this.applyEntitlementFieldLocks();
        if (this.globalSettings) {
          this.cdr.detectChanges();
        }
      },
    });
  }

  private syncSettingsAddOnApplicability(): void {
    const webcam = this.getCompanyAddOn('webcam_capture');
    if (this.userId) {
      const effective = this.settingsEntitlementsService.buildEmployeeEffectiveEntitlements(
        this.companyAddOns,
        this.userId
      );
      this.isWebcamCaptureEntitled = Boolean(effective['webcam_capture']?.enabled);
      return;
    }

    // Company-wide page: only entitle webcam when it is assigned company-wide or
    // to all users. A specific_users assignment must not enable it company-wide.
    const webcamEnabled = Boolean(webcam?.enabled || webcam?.effective_enabled);
    const webcamCompanyScoped =
      webcam?.assignment_mode === 'company' || webcam?.assignment_mode === 'all_users';
    this.isWebcamCaptureEntitled = webcamEnabled && webcamCompanyScoped;
  }

  private getCompanyAddOn(addonKey: string): CompanyAddOnEntitlement | undefined {
    return this.companyAddOns.find((addon) => addon.key === addonKey);
  }

  private resolveCompanyId(user: any): number {
    const rawCompanyId =
      user?.company_id
      ?? user?.companyId
      ?? user?.meta?.company_id
      ?? user?.meta?.companyId
      ?? user?.id;
    const companyId = Number(rawCompanyId);
    return Number.isFinite(companyId) && companyId > 0 ? companyId : 0;
  }

  private applySettingsEntitlementPayloadRules(settings: any): any {
    const normalized = { ...settings };

    if (!this.isWebcamCaptureEntitled) {
      normalized.ss_webcam = false;
    }

    return normalized;
  }

  webcamBadgeLabel(): string {
    return this.isWebcamCaptureEntitled ? 'Assigned' : 'Not assigned';
  }

  screenshotIntervalBadgeLabel(): string {
    const addon = this.getCompanyAddOn('custom_periodic_interval');
    const source = addon?.enabled && this.isCustomIntervalAddonInScope(addon)
      ? 'Add-on'
      : 'Core';
    return `${source}: ${this.minScreenshotCaptureMinutes()}-60 min`;
  }

  screenshotIntervalTooltip(): string {
    return `Available screenshot interval: ${this.minScreenshotCaptureMinutes()} to 60 minutes, based on the applicable core or add-on entitlement.`;
  }

  advancedModesBadgeLabel(): string {
    return this.canAdvancedScreenshotModes() ? 'Plan' : 'Plan locked';
  }

  private parseSettingBoolean(value: unknown, defaultValue = false): boolean {
    if (value === undefined || value === null) {
      return defaultValue;
    }
    if (typeof value === 'boolean') {
      return value;
    }
    return String(value).toLowerCase() === 'true';
  }

  /** Webcam toggle is read-only; reflect backend value without allowing edits. */
  private lockWebcamField(): void {
    const ctrl = this.globalSettings?.get('ss_webcam');
    if (!ctrl) {
      return;
    }
    // Assignment is still loading. Keep the saved value so a late "on" is not stuck as off.
    if (!this.webcamEntitlementKnown) {
      if (ctrl.enabled) {
        ctrl.disable({ emitEvent: false });
      }
      return;
    }
    const webcamEnabled = this.isWebcamCaptureEntitled
      ? this.parseSettingBoolean(this.globalSettingsData?.ss_webcam ?? ctrl.value)
      : false;
    if (ctrl.disabled) {
      ctrl.enable({ emitEvent: false });
    }
    ctrl.setValue(webcamEnabled, { emitEvent: false });
    ctrl.disable({ emitEvent: false });
  }

  /** Keep saved/API values on load; enforce plan minimum only when saving. */
  private clampScreenshotIntervalForSave(): void {
    const cap = this.globalSettings?.get('ss_screen_capture_time');
    if (!cap || cap.disabled) {
      return;
    }
    const floor = this.minScreenshotCaptureMinutes();
    const mins = this.getMinutes('ss_screen_capture_time', floor);
    if (mins < floor) {
      cap.setValue(this.minutesToHHMMSS(floor));
    }
  }

  /** App-switch requires Professional+; keep off and locked on Basic. */
  private applyAdvancedScreenshotModeFieldLocks(allowEnable = true): void {
    if (!this.globalSettings) {
      return;
    }
    const ctrl = this.globalSettings.get('ss_appchange');
    if (!ctrl) {
      return;
    }
    const shouldEnable = allowEnable && this.canAdvancedScreenshotModes() && !this.isPersonalized;
    if (!shouldEnable || !this.canAdvancedScreenshotModes()) {
      ctrl.setValue(false);
      ctrl.disable();
      return;
    }
    ctrl.enable();
  }

  incrementMinutes(controlName: 'ss_screen_capture_time' | 'ss_idle_time' | 'ss_appchange_interval', step: number): void {
    if (!this.globalSettings) return;
    const control = this.globalSettings.get(controlName);
    if (!control || control.disabled) return;
    if (controlName === 'ss_screen_capture_time') {
      this.refreshScreenshotIntervalFloor();
    }
    const floor =
      controlName === 'ss_screen_capture_time' ? this.screenshotCaptureMinMinutes : 1;
    const current = this.getMinutes(controlName, floor);
    if (controlName === 'ss_screen_capture_time' && step < 0 && current <= floor) {
      return;
    }
    const next = Math.max(floor, current + step);
    const capped = controlName === 'ss_screen_capture_time' ? Math.min(next, 60) : next;
    control.setValue(this.minutesToHHMMSS(capped));
    control.markAsDirty();
    control.updateValueAndValidity({ onlySelf: true, emitEvent: true });
    this.cdr.detectChanges();
  }

  setNewMinutes(controlName: 'ss_screen_capture_time' | 'ss_idle_time' | 'ss_appchange_interval', rawValue: number | string): void {
    if (!this.globalSettings) return;
    const control = this.globalSettings.get(controlName);
    if (!control || control.disabled) return;
    if (controlName === 'ss_screen_capture_time') {
      this.refreshScreenshotIntervalFloor();
    }
    const floor =
      controlName === 'ss_screen_capture_time' ? this.screenshotCaptureMinMinutes : 1;
    const parsed = Number(rawValue);

    // Clear existing debounce timeout for this control
    if (this.inputDebounceTimeouts[controlName]) {
      clearTimeout(this.inputDebounceTimeouts[controlName]);
    }

    // Set the current raw value temporarily without floor clamping so user can type freely (e.g. typing "1" then "5" to get "15")
    const next = Number.isFinite(parsed) ? Math.floor(parsed) : floor;
    const capped = controlName === 'ss_screen_capture_time' ? Math.min(next, 60) : next;
    control.setValue(this.minutesToHHMMSS(capped));
    control.markAsDirty();
    control.updateValueAndValidity({ onlySelf: true, emitEvent: true });

    // Enforce the plan minimum floor after a debounce to allow uninterrupted typing
    this.inputDebounceTimeouts[controlName] = setTimeout(() => {
      const currentVal = this.getMinutes(controlName, floor);
      if (currentVal < floor) {
        control.setValue(this.minutesToHHMMSS(floor));
        control.updateValueAndValidity({ onlySelf: true, emitEvent: true });
        this.cdr.detectChanges();
      }
    }, 500);

    this.cdr.detectChanges();
  }

  getDisplayMinutes(controlName: 'ss_screen_capture_time' | 'ss_idle_time' | 'ss_appchange_interval', fallback: number): number {
    return this.getMinutes(controlName, fallback);
  }

  checkConductIntegrationStatus(): void {
    const user = this.tokenEncryptionService?.getEncryptedItem<any>('user') || {};
    const companyId = user?.company_id || user?.id || user?.userId;
    this.isCheckingConductStatus = true;
    this.conductStatusError = false;
    this.isConductEnabled = false;
    this.isConductIntegrated = false;
    this._projectService.getConductIntegrationStatus(companyId).subscribe({
      next: (res: any) => {
        this.isCheckingConductStatus = false;
        if (res && res.success) {
          this.isConductEnabled = res.is_enabled === true ||
            (res.is_enabled === undefined && ['linked', 'unlinked'].includes(res.status));
          this.isConductIntegrated = !!res.is_integrated;
          if (res.conduct_url) {
            this.conductUrl = res.conduct_url;
          }
        } else {
          this.conductStatusError = true;
          this.isConductIntegrated = false;
        }
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        this.isCheckingConductStatus = false;
        this.conductStatusError = true;
        this.isConductIntegrated = false;
        this.isConductEnabled = false;
        console.error('Failed to fetch Conduct integration status:', err);
        this.cdr.detectChanges();
      }
    });
  }

  isImportingConductTimelogs = false;
  isNavigatingToConduct = false;

  goToConduct(): void {
    if (!this.isConductEnabled || this.isCheckingConductStatus || this.conductStatusError || this.isNavigatingToConduct || this.isDisconnectingConduct) return;
    this.isNavigatingToConduct = true;
    this.cdr.detectChanges();

    this._projectService.integrateConduct().subscribe({
      next: (res: any) => {
        this.isNavigatingToConduct = false;
        this.cdr.detectChanges();

        const token = res?.loginToken || (res?.data && res?.data?.loginToken) || (res?.data?.data && res?.data?.data?.loginToken);
        const conductUrl = environment.app.conductUrl || this.conductUrl;
        if (!conductUrl) {
          swal.fire('Unable to open Conduct', 'CONDUCT_URL is not configured for this environment.', 'error');
          return;
        }
        const cleanUrl = conductUrl.endsWith('/') ? conductUrl : conductUrl + '/';

        if (token) {
          window.open(`${cleanUrl}sso?loginToken=${token}`, '_blank');
        } else {
          window.open(cleanUrl, '_blank');
        }
      },
      error: (err: any) => {
        this.isNavigatingToConduct = false;
        this.cdr.detectChanges();
        console.error('Failed to fetch Conduct SSO token:', err);
        swal.fire('Unable to open Conduct', err?.error?.message || 'Please try again.', 'error');
        this.checkConductIntegrationStatus();
      }
    });
  }

  importConductTimelogs(): void {
    const user = this.tokenEncryptionService.getEncryptedItem<any>('user') || {};
    const companyId = user?.company_id || user?.id || user?.userId || 0;

    this.isImportingConductTimelogs = true;
    this.cdr.detectChanges();

    const today = moment().format('YYYY-MM-DD');
    this._projectService.fetchConductTimelogs({
      supersee_company_id: companyId,
      requesting_user_id: user?.id,
      start_date: today,
      end_date: today
    }).subscribe({
      next: (res: any) => {
        this.isImportingConductTimelogs = false;
        const timelogs = res?.timelogs || res?.data || (Array.isArray(res) ? res : []);
        const count = timelogs.length || res?.count || 0;
        swal.fire({
          title: 'Time logs imported',
          text: `${count} time log${count === 1 ? '' : 's'} from Conduct ${count === 1 ? 'was' : 'were'} added.`,
          icon: 'success',
          confirmButtonText: 'Done',
        });
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        this.isImportingConductTimelogs = false;
        console.error('Import Conduct Timelogs Error:', err);
        swal.fire({
          title: "Couldn't import time logs",
          text: 'Check that Conduct is connected, then try again.',
          icon: 'error',
          confirmButtonText: 'Close',
        });
        this.cdr.detectChanges();
      }
    });
  }

  disconnectConduct(): void {
    if (!this.isConductEnabled || this.isCheckingConductStatus || this.conductStatusError || this.isDisconnectingConduct || this.isNavigatingToConduct) return;
    swal.fire({
      title: 'Disconnect Conduct?',
      html: '<p>SuperSee will stop receiving new time logs from Conduct.</p>',
      showCancelButton: true,
      confirmButtonColor: '#32357d',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Disconnect Conduct',
      cancelButtonText: 'Keep connected',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.isDisconnectingConduct = true;
        this._projectService.disconnectConduct().subscribe({
          next: (res: any) => {
            this.isDisconnectingConduct = false;
            if (res && res.success) {
              this.isConductIntegrated = false;
              swal.fire({
                icon: 'success',
                title: 'Conduct disconnected',
                text: 'SuperSee will no longer receive new time logs from Conduct.',
                confirmButtonText: 'Done',
              });
            } else {
              swal.fire({
                icon: 'error',
                title: "Couldn't disconnect Conduct",
                text: 'Try again. If this keeps happening, contact support.',
                confirmButtonText: 'Close',
              });
            }
            this.cdr.detectChanges();
          },
          error: (err: any) => {
            this.isDisconnectingConduct = false;
            console.error('Disconnect Error:', err);
            swal.fire({
              icon: 'error',
              title: "Couldn't disconnect Conduct",
              text: 'Try again. If this keeps happening, contact support.',
              confirmButtonText: 'Close',
            });
            this.cdr.detectChanges();
          }
        });
      }
    });
  }

  integrateConduct() {
    if (!this.isConductEnabled || this.isCheckingConductStatus || this.conductStatusError || this.isIntegratingConduct) return;
    this.isIntegratingConduct = true;
    this._projectService.integrateConduct().subscribe({
      next: (res: any) => {
        console.log("Response from the conduct integration", res);
        this.isIntegratingConduct = false;

        if (res && res.success) {
          this.isConductIntegrated = true;
          this.checkConductIntegrationStatus();
          // If WordPress sends the loginToken inside data
          const token = res.loginToken || (res.data && res.data.loginToken);

          if (token) {
            swal.fire({
              title: 'Success!',
              text: 'Conduct has been successfully integrated. You are now being redirected...',
              icon: 'success',
              confirmButtonText: 'OK',
              confirmButtonColor: '#3085d6'
            }).then(() => {
              const conductUrl = environment.app.conductUrl || this.conductUrl;
              if (!conductUrl) {
                return;
              }
              const cleanUrl = conductUrl.endsWith('/') ? conductUrl : conductUrl + '/';
              window.open(`${cleanUrl}sso?loginToken=${token}`, '_blank');
            });
          } else {
            swal.fire({
              title: 'Success!',
              text: 'Conduct has been successfully integrated.',
              icon: 'success',
              confirmButtonText: 'OK',
              confirmButtonColor: '#3085d6'
            });
          }
        } else {
          swal.fire({
            title: 'Error!',
            text: res?.message || 'Failed to integrate Conduct. Please try again.',
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6'
          });
        }
      },
      error: (err) => {
        this.isIntegratingConduct = false;
        console.error('Integration Error:', err);
        swal.fire({
          title: 'Error!',
          text: err?.error?.message || 'Failed to integrate Conduct. Please try again later.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#3085d6'
        });
      }
    });
  }
}
@Injectable({
  providedIn: 'root'
})
export class FormGuard implements CanDeactivate<UserSettingPanelComponent> {
  constructor(public _dialog: MatDialog) {
  }
  canDeactivate(
    component: UserSettingPanelComponent
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const hasUnsaved = !!component.globalSettings?.dirty
      || (!component.userId && component.isDeliveryDirty);
    if (hasUnsaved) {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.autoFocus = true;

      dialogConfig.minWidth = 400;

      const dialogRef = this._dialog.open(DialogTemplateComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {

        if (result) {
          if (component.userId) {
            component.getUserDetails();
          } else {
            component.getGlobalSettings()
          }
          component.createGlobalSettingsForm()
        } else {
          component.onSettingsSave();
        }

      });
      return false;
    } else {
      return true;
    }
  }
}
